// Seasonal / holiday themes for the Mochi room. Auto-selected by date.
export const SEASONS = {
  valentine: {
    id: "valentine", label: "Musim Kasih", emoji: "💕",
    bg: "radial-gradient(ellipse at 36% 30%,#ffe9ef 0%,#ffd0dd 58%,#f6b6c8 100%)",
    particle: "#ff5a5f", bed: "#f4a9bd", badge: "#e0484d", suggest: "flower",
    note: "Suasana penuh cinta untuk kalian berdua.",
  },
  merdeka: {
    id: "merdeka", label: "Musim Merdeka", emoji: "🇮🇩",
    bg: "radial-gradient(ellipse at 36% 30%,#fff4f4 0%,#ffdada 52%,#eafff0 100%)",
    particle: "#e0484d", bed: "#d98a8a", badge: "#c9363b", suggest: "crown",
    note: "Merayakan kemerdekaan bareng Mochi.",
  },
  liburan: {
    id: "liburan", label: "Musim Liburan", emoji: "❄️",
    bg: "radial-gradient(ellipse at 36% 30%,#eef6ff 0%,#d3e6f7 58%,#bcd6ee 100%)",
    particle: "#a9cef0", bed: "#9fc0dc", badge: "#4f86b8", suggest: "scarf",
    note: "Udara sejuk, waktunya hangat-hangatan.",
  },
  hangat: {
    id: "hangat", label: "Musim Hangat", emoji: "☀️",
    bg: "radial-gradient(ellipse at 36% 30%,#fbf6ed 0%,#eee4d5 62%,#e0d2c0 100%)",
    particle: "#f3c9a0", bed: "#b9d4e8", badge: "#c9955a", suggest: "hat",
    note: "Hari cerah untuk main bareng Mochi.",
  },
};

export const SEASON_ORDER = ["hangat", "valentine", "merdeka", "liburan"];

export function autoSeason(d = new Date()) {
  const m = d.getMonth() + 1;
  const day = d.getDate();
  if (m === 2 && day >= 7 && day <= 17) return "valentine";
  if (m === 8 && day >= 10 && day <= 18) return "merdeka";
  if (m === 12 || m === 1) return "liburan";
  return "hangat";
}
